// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 486) return "static/chunks/486-0ebad796acd89bf3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"316":"7d20d3cc8833cefd","786":"9b1f33e87e215076","818":"4eae91fb5badf441"}[chunkId] + ".js";
};